import React from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Button, Space } from 'antd';
import { ApiOutlined, LogoutOutlined } from '@ant-design/icons';
import { clearKedoSession, getKedoUser } from './kedoApi';
import './KedoShell.css';

const nav = [
    { to: '/kedo/app', end: true, label: 'Рабочий стол' },
    { to: '/kedo/app/documents', label: 'Документы' },
    { to: '/kedo/app/counterparties', label: 'Контрагенты' },
    { to: '/kedo/app/mchd', label: 'МЧД' },
    { to: '/kedo/app/settings', label: 'Настройки' },
    { to: '/kedo/app/audit', label: 'Журнал' }
];

const KedoLayout = () => {
    const navigate = useNavigate();
    const user = getKedoUser();

    const logout = () => {
        clearKedoSession();
        navigate('/kedo');
    };

    return (
        <div className="kedo-shell">
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=Source+Serif+4:opsz,wght@8..60,600;8..60,700&display=swap"
            />
            <header className="kedo-topbar">
                <Link to="/kedo/app" className="kedo-brand">
                    <span className="kedo-brand-mark">Kedo</span>
                    <span className="kedo-brand-sub">КЭДО / ЭДО</span>
                </Link>
                <nav className="kedo-nav">
                    {nav.map(item => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            className={({ isActive }) =>
                                isActive ? 'active' : undefined
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>
                <Space wrap>
                    <span style={{ opacity: 0.7, fontSize: 13 }}>
                        {user?.full_name || user?.email || ''}
                    </span>
                    <Button
                        icon={<ApiOutlined />}
                        href="/api/kedo/v1/docs"
                        target="_blank"
                    >
                        Swagger
                    </Button>
                    <Button icon={<LogoutOutlined />} onClick={logout}>
                        Выйти
                    </Button>
                </Space>
            </header>
            <main className="kedo-main">
                <Outlet />
            </main>
        </div>
    );
};

export default KedoLayout;
